import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CanvasService } from '../canvas.service';
import { uniqBy } from 'lodash';
import { Subscription } from 'rxjs';
import { SnackbarService } from 'src/app/services/common/snackbar.service';
import { Constants } from 'src/app/utils/constants';
import { CanvasLoaderType } from '../canvas.model';
import { CanvasHelperService } from '../canvas-helper.service';

@Component({
  selector: 'app-canvas-chat',
  templateUrl: './canvas-chat.component.html',
  styleUrl: './canvas-chat.component.scss',
})
export class CanvasChatComponent implements OnInit, OnDestroy {
  @Output() onCanvasClose = new EventEmitter();
  @Output() onCanvasExpand = new EventEmitter();
  @Input() isEmbededChat: boolean = false;
  @Input() isLoadingChatConversations: boolean = false;
  @Input() nofo: string = '';

  onBookmarkNavigationSub!: Subscription;
  userText: string = '';
  fileSelected: any = [];

  acceptedFiles = Constants.GRANT_OTHER_DOCUEMNTS;
  loaderTypes = CanvasLoaderType;

  closeChat() {
    this.onCanvasClose.emit();
  }

  constructor(
    public hubService: CanvasService,
    private readonly snack: SnackbarService,
    private readonly helperService: CanvasHelperService
  ) {}

  ngOnDestroy(): void {
    this.onBookmarkNavigationSub?.unsubscribe();
  }

  ngOnInit() {
    this.onBookmarkNavigationSub =
      this.hubService.onBookmarkNavigationSubject$.subscribe(
        (bookmark: any) => {
          this.hubService.scrollDown(
            bookmark?.conversation,
            bookmark?.isBookmark ?? false
          );
        }
      );
  }

  sendMessage() {
    if (
      this.userText?.length > 0 &&
      this.helperService.checkIfConversationAllowed(
        this.hubService.conversationSettings,
        this.hubService.currentChatMessages
      )
    ) {
      this.hubService.postChatMessage(
        this.userText,
        this.hubService.currentChatMessages?.length <= 1 ? this.nofo : undefined
      );
    }
    this.userText = '';
  }

  openChatInfo() {
    console.log('open chat info');
  }

  expandChat() {
    this.onCanvasExpand.emit();
  }

  handleFileInputClick(filesInputEvent: any) {
    if (filesInputEvent) {
      filesInputEvent.target.value = '';
    }
  }

  onFileSelected(filesInputEvent: any) {
    this.handleFileInput(filesInputEvent?.target?.files);
  }

  handleFileInput(filesInputEvent: any) {
    this.fileSelected = [];
    if (filesInputEvent) {
      if (!this.isValidDataSet(filesInputEvent)) {
        return;
      }

      this.fileSelected = [...this.fileSelected, ...filesInputEvent];
      this.fileSelected = uniqBy(this.fileSelected, 'name');
    }

    if (this.fileSelected?.length > 0) {
      this.hubService.openAddChatDocumentsDialog(this.fileSelected);
    }
  }

  isValidDataSet(filesInputEvent: any) {
    let temp: any = [];
    for (let file of filesInputEvent) {
      temp.push(file);
    }

    if (
      !temp?.every(
        (it: any) =>
          String(it.name).toLocaleLowerCase().endsWith('.xls') ||
          String(it.name).toLocaleLowerCase().endsWith('.docx') ||
          String(it.name).toLocaleLowerCase().endsWith('.doc') ||
          String(it.name).toLocaleLowerCase().endsWith('.xlsx') ||
          String(it.name).toLocaleLowerCase().endsWith('.xlsm') ||
          String(it.name).toLocaleLowerCase().endsWith('.csv') ||
          String(it.name).toLocaleLowerCase().endsWith('.txt') ||
          it.type == 'application/pdf' ||
          it.type == 'image/png' ||
          it.type == 'image/jpeg'
      )
    ) {
      this.snack.openInfoBar(
        'Only Excels, Word, Text, PDF and Image files are allowed'
      );
      return false;
    }

    return true;
  }

  trackById(index: number, item: any) {
    return item.id ?? index;
  }
  getTotalUsageCost() {
    let total = 0;
    this.hubService.currentChatMessages?.forEach((message: any) => {
      message.responses?.forEach((res: any) => {
        total += res.stats?.usage_cost ?? 0;
      });
    });
    return `Total cost: $${Number(total?.toFixed(4))}`;
  }
}
